export const TAGLINE = "Production-ready boilerplate for vibe coders."

export const HERO_SLOGAN = "Vibe it. Code it. Ship it."

export const HERO_SLOGANS = [
  HERO_SLOGAN,
  "Hack it. Test it. Deploy it.",
  "Dream it. Build it. Launch it.",
]
